import { useCallback } from "react"
import { DashBoardCondition } from "features/dashBoard/types"
import { useTimeLineGraphOption } from "./options"

type useTimeLineGraphEventsProps<T> = {
	graphOption: ReturnType<typeof useTimeLineGraphOption<T>>
	onChangeCondition: (
    axisKey?: string,
    changed?: DashBoardCondition,
    toggle?: boolean
  ) => void
}
export const useTimeLineGraphEvents = <T,>({
	graphOption: {
		timeDef
	},
	onChangeCondition
}: useTimeLineGraphEventsProps<T>) => {
	const onClickGraph = useCallback(
		(params?: {
			event?: { event?: { ctrlKey?: boolean } }
			data: { key: string, name: string }
		}) => {
			const data = params?.data
			if (!data) return
			onChangeCondition(
				timeDef?.key,
				{ code: [data.key], label: data.name },
				params?.event?.event?.ctrlKey ? true : false
			)
		},
		[timeDef, onChangeCondition]
	)
	return {
		click: onClickGraph
	}
}